import { Stack } from "@mui/material";
import { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import AccessModeMenuLabel from "../AccessModeMenuLabel";
import AuthorizationGroupItem from "./AuthorizationGroupItem";
import type { GroupItem } from "./authorizedItems.ts";

interface AuthorizedGroupsListProps {
  items: GroupItem[];
  disabled: boolean;
  onAccessChanged: (groupId: string, access: ReportAccessType) => void;
  onRemoveGroup: (groupId: string) => void;
}

export default function AuthorizedGroupsList({
  items,
  disabled,
  onAccessChanged,
  onRemoveGroup,
}: AuthorizedGroupsListProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Stack spacing={2}>
      {items.map((group) => (
        <Stack key={group.groupId} direction={"row"} spacing={1.5} sx={{ alignItems: "center" }}>
          <AuthorizationGroupItem name={group.name} memberCount={group.memberCount} iconSize="medium" />
          <HorizontalFill />
          <AccessModeMenuLabel
            access={group.access}
            allowedAccesses={[ReportAccessType.FullAccess, ReportAccessType.Write, ReportAccessType.Read]}
            hasRemove
            disabled={disabled}
            onSelect={(access) => onAccessChanged(group.groupId, access)}
            onRemove={() => onRemoveGroup(group.groupId)}
          />
        </Stack>
      ))}
    </Stack>
  );
}
